import { Button } from '@travelnest/hui';
import React from 'react';

import { P } from '../typography/P';
import {
	GradientInfoCardWithImageStyled,
	GradientOverlay,
} from './GradientInfoCardWithImage.styled';

export interface IGradientInfoCardProps {
	children?: React.ReactNode;
	image: 'calendar' | 'website';
	colour: 'green' | 'blue';
	title: string;
	description: string;
	buttonText: string;
	buttonVariant: 'primary' | 'positive';
	onClick: () => void;
}

export const GradientInfoCardWithImage = (props: IGradientInfoCardProps) => {
	const {
		title,
		description,
		buttonText,
		buttonVariant,
		onClick,
		image,
		colour,
	} = props;

	const imageToPathMap: Record<string, string> = {
		calendar: '/92b3b47/assets/images/tiles/calendar.png',
		website: '/92b3b47/assets/images/tiles/website.png',
	};

	return (
		<GradientInfoCardWithImageStyled colour={colour}>
			<h3>{title}</h3>
			<P>{description}</P>
			<Button
				text={buttonText}
				variant={buttonVariant}
				fill="light"
				style={{ marginTop: '8px' }}
				onClick={onClick}
			/>

			<img src={imageToPathMap[image]} />
			<GradientOverlay colour={colour} />
		</GradientInfoCardWithImageStyled>
	);
};
